import React, {Component} from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import Home from "../../pages/home/component";
import About from "../../pages/about/component";
import SignupImage from "../../pages/signup-image/component";
import SignupQuotes from "../../pages/signup-quotes/component";
import SignupAds from "../../pages/signup-ads/component";
import SignupFilter from "../../pages/signup-filter/component";
import SignupCheckout from "../../pages/signup-checkout/component";
import SignupPayment from "../../pages/signup-payment/component";
import SignupConfirmation from "../../pages/signup-confirmation/component";
import Register from "../../pages/register/component";
import Login from "../../pages/login/component";
import User from "../../pages/user/component"
import SignupBudget from "../../pages/signup-budget/component";
import ForgotPassword from "../../pages/forgotpassword/component";
import Reseller from "../../pages/reseller/component";
import LoginPin from "../../pages/login-pin/component";
import PinVerification from "../../pages/pin-verification/component";
import NoPage from "../../pages/no-page/component";
import Error from "../../pages/error/component";
import {marketRegister} from "../../services/marketRegister";
import fetchIntercept from 'fetch-intercept';
import {tokenRegister} from "../../services/tokenRegister";
import ResetPassword from "../../pages/resetpassword/component";
import RouterWrapper from "../router-wrapper/component";
import SelectMarket from "../../pages/select-market/component";
import {userRegister} from "../../services/userRegister";
import {dataRegister} from "../../services/dataRegister";

class Main extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount(){
        this._setInterceptor();
    }

    _setInterceptor(){
        const unregister = fetchIntercept.register({
            request: function (url, config) {
                return [url, config];
            },

            requestError: function (error) {
                return Promise.reject(error);
            },

            response: function (response) {
                if(response.headers.get('X-Jwt-Token')){
                    tokenRegister.set(response.headers.get('X-Jwt-Token'));
                }
                if(response.status === 200){
                    return response;
                }else if(response.status === 401){
                    userRegister.remove();
                    tokenRegister.remove();
                    return Promise.reject(response);
                } else{
                    return Promise.reject(response);
                }
            },

            responseError: function (error) {
                return Promise.reject(error);
            }
        });
    }

    render() {
        return (
            <BrowserRouter>
                <Switch>

                    /*SWEDEN*/
                    <Route path="/:market/:lang" component={RouterWrapper}/>

                    /*SELECT MARKET*/
                    <Route path="/select-market" component={SelectMarket}/>
                    <Route component={SelectMarket}/>

                </Switch>
            </BrowserRouter>
        )
    }

}

export default Main


// WEBPACK FOOTER //
// ./src/components/main/component.js